'use strict';

const SELECTOR = '.donation-panel';

export function init() {
    document.querySelectorAll(SELECTOR).forEach(element => {
        const otherButton = element.querySelector('.donation-panel__input--other');
        const customAmountInput = element.querySelector('[name="custom"]');

        if (otherButton){

            otherButton.addEventListener('click', () => {
                element.querySelector('.donation-panel__amounts').classList.add('hidden');
                element.querySelector('.donation-panel__input--custom').classList.remove('hidden');

                customAmountInput.tabIndex = 0;
                customAmountInput.focus();

            element.querySelectorAll('[type="radio"]').forEach(radio => {
                radio.required = false;
            });

            element.querySelector('[type="number"]').required = true;
        });


        element.addEventListener('submit', event => {
            event.preventDefault();

            const cid = event.target.dataset.contribution;
            const checkedRadio = element.querySelector('[name="amount"]:checked');
            let amount = checkedRadio ? checkedRadio.value : '';

            // const ct = event.target.ct.value;
            if (customAmountInput && customAmountInput.value > 0) {
                amount = customAmountInput.value;
            }

            if(!cid) {
                return;
            }

            if (!amount) {
                return alert('Please select a donation amount');
            }

            window.location.href = `${event.target.action}${cid}/add-to-basket/${amount}`;
        });
    }
    });
}
